export default __webpack_public_path__ + "static/media/safepal.856c5ea8.svg";